"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Mission() {
  const {
    ref: h2Ref,
    isVisible: h2Visible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: whyRef,
    isVisible: whyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.15
  });
  const {
    ref: founderH3Ref,
    isVisible: founderH3Visible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: bioRef,
    isVisible: bioVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.15
  });
  const {
    ref: graphRef,
    isVisible: graphVisible
  } = useRevealOnScroll<HTMLImageElement>({
    threshold: 0.15
  });
  const {
    ref: systemH3Ref,
    isVisible: systemH3Visible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: btnRef,
    isVisible: btnVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: descRef,
    isVisible: descVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.15
  });
  const revealStyles = (visible: boolean, delay: string = "0ms") => ({
    opacity: visible ? 1 : 0,
    transform: visible ? "translateY(0)" : "translateY(16px)",
    transition: `opacity 720ms cubic-bezier(0.22, 0.61, 0.36, 1) ${delay}, transform 720ms cubic-bezier(0.22, 0.61, 0.36, 1) ${delay}`
  });
  return <section data-section-id="19027" id="our-mission" className="bg-background text-foreground ![padding:60px_0px_60px_0px]">
      <div className="container max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-start">
          {}
          <div className="text-left">
            <h1 ref={h2Ref} className="font-default font-bold text-primary mb-8" style={{
            fontSize: "clamp(2rem, 4vw, 3rem)",
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
            ...revealStyles(h2Visible)
          }}>
              Why NoMoCo
            </h1>
            <p ref={whyRef} className="font-default text-foreground mb-12 !text-xl" style={{
            fontSize: "clamp(1rem, 1.1vw, 1.125rem)",
            lineHeight: 1.7,
            ...revealStyles(whyVisible, "100ms")
          }}>
              NoMoCo's pillow support system kits were designed as head restraint kits due to a crucial need by researchers in the field of neuroimaging (MRI, fMRI, PET, and SPECT) to collect accurate output data. Other devices, including bite bars, inflatable bead bags, head and neck braces, and polyurethane molded masks, have resulted in many failed attempts to collect quality image data with no movement. NoMoCo's pillow system provides the support, comfort and sensory feedback necessary to help researchers and technologists acquire more usable data due to the minimization of subject head movement. The kits can also be used for Computerized Axial Tomography exams.
            </p>

            
            
            
            
          </div>

          {}
          <div className="flex flex-col items-start md:items-end text-left md:text-right">
            
            <h3 ref={systemH3Ref} className="text-primary font-semibold mb-6" style={{
            fontSize: "1.25rem",
            ...revealStyles(systemH3Visible, "100ms")
          }}>
              The NoMoCo Pillow System
            </h3>
            
            <img ref={graphRef} src="https://nomocopillow.com/wp-content/uploads/2026/06/pillowsystem.webp" alt="NoMoCo Pillow support system helping stabilize a person’s head during a brain imaging scan." className="w-full max-w-md mb-0" loading="lazy" style={revealStyles(graphVisible)} />
            <img ref={graphRef} src="https://nomocopillow.com/wp-content/uploads/2026/06/chart2.webp" alt="NoMoCo Pillow neuroimaging patient positioning system with memory foam support pads for reducing motion during brain MRI scans" className="w-full max-w-md mb-8" loading="lazy" style={revealStyles(graphVisible)} />
            <div ref={btnRef} style={revealStyles(btnVisible, "200ms")} className="w-full md:w-auto">
              <Button asChild className="w-full md:w-auto px-8 py-6 text-lg font-bold uppercase tracking-wider rounded-lg shadow-md hover:shadow-lg transition-all">
                <Link to="https://nomocopillow.com/wp-content/uploads/2026/06/NoMoCoAbstracts.pdf" newTab>
                  Download Studies PDF
                </Link>
              </Button>
            </div>
            <p ref={descRef} className="mt-6 font-default text-muted-foreground max-w-md" style={{
            fontSize: "0.9375rem",
            lineHeight: 1.6,
            ...revealStyles(descVisible, "300ms")
          }}>
              Access our comprehensive collection of research abstracts and clinical studies validating the effectiveness of the NoMoCo Pillow Support System in professional imaging environments.
            </p>
          </div>
        </div>
      </div>
    </section>;
}